module.exports = __webpack_public_path__ + "static/media/covi_wel_was.587df868.png";